import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ETPermissions } from '@et/typings';
import { Store } from '@ngxs/store';
import { map } from 'rxjs';
import { waitForProfileUserType } from '@et/guards';

const LENDER_LANDING_PERMISSIONS = new Set<string>([
  ETPermissions.LenderClosingDepartment,
  ETPermissions.LenderLoanOfficer,
]);

export const landingGuard: CanActivateFn = () => {
  const router = inject(Router);

  return waitForProfileUserType(inject(Store)).pipe(
    map((userType) =>
      router.createUrlTree([
        userType && LENDER_LANDING_PERMISSIONS.has(userType)
          ? '/app/orders'
          : '/app/doc-list',
      ]),
    ),
  );
};
